import { Input } from '@appkit4/react-components/field';
import { useCallback, useState } from 'react';

export interface EngagementFormData {
    engagementName: string;
    clientName: string;
    wbsCode: string;
    description: string;
}

interface EngagementFormProps {
    formData: EngagementFormData;
    onChange: (field: keyof EngagementFormData, value: string) => void;
}

const EngagementForm = ({ formData, onChange }: EngagementFormProps) => {
    return (
        <>
            <Input
                type={'text'}
                title={'Engagement name'}
                required
                value={formData.engagementName}
                onChange={(value: string) => onChange('engagementName', value)}
            />
            <Input
                type={'text'}
                title={'Client name'}
                required
                value={formData.clientName}
                onChange={(value: string) => onChange('clientName', value)}
            />
            <Input
                type={'text'}
                title={'WBS Code'}
                required
                value={formData.wbsCode}
                onChange={(value: string) => onChange('wbsCode', value)}
            />
            <Input
                type={'text'}
                title={'Description'}
                value={formData.description}
                onChange={(value: string) => onChange('description', value)}
            />
        </>
    );
};

export default EngagementForm;
